import type { TMedia } from '~constants/media';
import { ImageRenderer } from '~shared/ui/molecules';

import { CarouselList, GridCarouselItem } from './styles';

type TCarouselProps = {
	items?: TMedia[][];
	fallbacks: string[];
};

export const GridCarousel = ({
	items = [],
	fallbacks = [],
}: TCarouselProps) => {
	const images = items.length ? items : fallbacks;

	return (
		<CarouselList>
			{images.map((_, index) => (
				<GridCarouselItem key={index} tabIndex={0}>
					<ImageRenderer
						item={items[index]}
						fallback={fallbacks[index]}
						width={300}
						height={400}
						quality={85}
						fetchPriority={index === 0 ? 'high' : 'low'}
						showLowQualityPreview={index < 2}
						alt=""
					/>
				</GridCarouselItem>
			))}
		</CarouselList>
	);
};
